// extracted by mini-css-extract-plugin
export var cartIcon = "_nn-0";
export var cartIconContainer = "_nn-1";